import { useEffect, useRef } from "react";

// Internet connection toasts: while the browser is offline a toast that can't be closed says
// so (setStickyToast); once it is back that one goes and a green "restored" toast shows
// (showMsg). Nothing on a page that simply opens online.
const OFFLINE_TOAST = "internet-offline";
export const OFFLINE_MSG = "No internet connection. Changes can't reach viewers until it's back.";
export const ONLINE_MSG = "Internet connection restored";

export default function useConnectionToasts(online, showMsg, setStickyToast) {
  const wasOfflineRef = useRef(false);

  useEffect(() => {
    if (!online) {
      wasOfflineRef.current = true;
      setStickyToast?.(OFFLINE_TOAST, OFFLINE_MSG);
      return;
    }
    setStickyToast?.(OFFLINE_TOAST, null);
    if (wasOfflineRef.current) {
      wasOfflineRef.current = false;
      showMsg?.(ONLINE_MSG, "success");
    }
  }, [online, showMsg, setStickyToast]);

  // Leaving the page clears it.
  useEffect(() => () => setStickyToast?.(OFFLINE_TOAST, null), [setStickyToast]);
}
